import { createSlice } from 'utils/@reduxjs/toolkit';
import { PucksState } from './types';
import { reducers } from './reducers';

export const initialState: PucksState = {
  isLoading: false,
  data: null,
  error: null,
};

const slice = createSlice({
  name: 'pucks',
  initialState,
  reducers,
});

export const { actions: pucksActions } = slice;
export const { reducer: pucksReducer } = slice;
